import React, {useState, useEffect} from 'react';

import {isEmpty} from "../../utils/validations";
import {getAllPublications} from "../../knowledgeBank/KnowledgeBankAction";

import PublicationsView from "./PublicationsView";

const Publications = (props) => {
    const [publicationState, setPublicationState] = useState({
        publications: [],
        isApiInProgress: false,
        apiErrorMessage: '',
        open: false,
        vertical: 'top',
        horizontal: 'right',
    });

    useEffect(() => {
        getPublications();
    }, []);

    const handleClick = (newState) => () => {
        setPublicationState(prevState => ({
            ...prevState,
            ...newState,
            open: true,
        }));
    };

    const handleClose = () => {
        setPublicationState(prevState => ({
            ...prevState,
            open: false,
        }));
    };

    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url)
            .then(
                handleClick({vertical: 'top', horizontal: 'right'})
            )
            .catch(err => {
                console.error('Error copying text: ', err);
            });
    };

    const getPublications = () => {
        setPublicationState(prevState => ({
            ...prevState,
            isApiInProgress: true,
        }));
        getAllPublications()
            .then(res => {
                if (res.success) {
                    setPublicationState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        publications: (isEmpty(res.data) || isEmpty(res.data.publications)) ? [] : res.data.publications,
                    }));
                } else {
                    setPublicationState(prevState => ({
                        ...prevState,
                        isApiInProgress: false,
                        apiErrorMessage: res.__error,
                    }));
                }
            });
    };

    return (
        <PublicationsView
            {...props}
            {...publicationState}
            handleClose={handleClose}
            copyToClipboard={copyToClipboard}
        />
    );
};

export default Publications;